import { all, call, put, take } from 'redux-saga/effects';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import * as types from 'src/state/ducks/bakedBreadTag/types';
import * as actions from 'src/state/ducks/bakedBreadTag/actions';
import * as api from 'src/state/ducks/bakedBreadTag/api';
import { Status } from 'src/constants/Interface';
import { toaster } from 'src/helpers/UtilityHelper';
import ValidationManager from 'src/firebase/db/ValidationManager';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { BakedBreadTagEntity, bakedBreadTagEntityKeys } from 'src/firebase/db/BakedBreadTags';

dayjs.extend(isSameOrAfter);

function* validateBakedBreadTag() {
  while (true) {
    const { payload } = yield take(types.VALIDATE_BAKED_BREAD_TAG);

    // 入力された値を検証する
    const form = payload as BakedBreadTagEntity;
    const validator = new ValidationManager();

    // 入力必須
    const IS_REQUIRED = ['name'];

    bakedBreadTagEntityKeys.forEach((key) => {
      if (IS_REQUIRED.includes(key)) {
        validator.isRequired(key, form[key]);
      }

      switch (key) {
      }
    });

    if (validator.isPass()) {
      // yield put(push(`/order/create/confirm}`));
      yield put(actions.successValidateBakedBreadTag(payload));
    } else {
      const errors = validator.throwValidateError(validator.getErrors());
      yield put(actions.failValidateBakedBreadTag(errors));
    }
  }
}

function* getBakedBreadTags() {
  while (true) {
    yield take(types.GET_BAKED_BREAD_TAGS);
    try {
      const res = yield call(api.getBakedBreadTags);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetBakedBreadTags(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failGetBakedBreadTags(res));
      }
    } catch (err) {
      yield put(
        actions.failGetBakedBreadTags({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* createBakedBreadTag() {
  while (true) {
    const { payload } = yield take(types.CREATE_BAKED_BREAD_TAG);
    try {
      const res = yield call(api.createBakedBreadTag, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successCreateBakedBreadTag(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failCreateBakedBreadTag(res));
      }
    } catch (err) {
      console.log({ err });
      yield put(
        actions.failCreateBakedBreadTag({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* updateBakedBreadTags() {
  while (true) {
    const { payload } = yield take(types.UPDATE_BAKED_BREAD_TAGS);
    const bakedBreadTags = payload as BakedBreadTagEntity[];
    try {
      const res = yield all(
        bakedBreadTags.map((bakedBreadTag) => call(api.updateBakedBreadTags, bakedBreadTag)),
      ) || [];
      const checkResponseStatus = (status: number) =>
        res.every(
          (v: APISuccessfulResponse<BakedBreadTagEntity[]> | APIFailedResponse) =>
            v.status === status,
        );
      if (checkResponseStatus(Status.SUCCESS)) {
        yield put(actions.successUpdateBakedBreadTags(res));
        toaster('success', '更新しました');
      } else if (checkResponseStatus(Status.INVALID)) {
        yield put(actions.failUpdateBakedBreadTags(res));
      }
    } catch (err) {
      console.log({ err });
      yield put(
        actions.failUpdateBakedBreadTags({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* deleteBakedBreadTag() {
  while (true) {
    const { payload } = yield take(types.DELETE_BAKED_BREAD_TAG);
    try {
      const res = yield call(api.deleteBakedBreadTag, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successDeleteBakedBreadTag(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failDeleteBakedBreadTag(res));
      }
    } catch (err) {
      console.log({ err });
      yield put(
        actions.failDeleteBakedBreadTag({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

const bakedBreadTag = [
  getBakedBreadTags(),
  validateBakedBreadTag(),
  createBakedBreadTag(),
  updateBakedBreadTags(),
  deleteBakedBreadTag(),
];

export default bakedBreadTag;
